import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ti18n from 'i18n!nls/Sequenceri18n';
import TrebbleSlider from "./common/TrebbleSlider";

const EditorSearchParamsForSilenceSearch = ({ 
    searchParams, 
    onSearchParamsChange,
    searchWidgetModel 
}) => {
    // Enum for silence threshold options (discrete steps)
    const SILENCE_THRESHOLD = {
        FAST: 0,      // All
        SMOOTH: 1,    // ≥ 1s
        RELAXED: 2    // ≥ 3s
    };

    // Threshold configuration with i18n keys
    const THRESHOLD_CONFIG = {
        [SILENCE_THRESHOLD.FAST]: {
            labelKey: 'SILENCE_THRESHOLD_FAST_LABEL',
            ruleLabelKey: 'SILENCE_THRESHOLD_FAST_RULE_LABEL',
            helperKey: 'SILENCE_THRESHOLD_FAST_HELPER',
            platformsKey: 'SILENCE_THRESHOLD_FAST_PLATFORMS',
            seconds: 0
        },
        [SILENCE_THRESHOLD.SMOOTH]: {
            labelKey: 'SILENCE_THRESHOLD_SMOOTH_LABEL',
            ruleLabelKey: 'SILENCE_THRESHOLD_SMOOTH_RULE_LABEL',
            helperKey: 'SILENCE_THRESHOLD_SMOOTH_HELPER',
            platformsKey: 'SILENCE_THRESHOLD_SMOOTH_PLATFORMS',
            seconds: 1
        },
        [SILENCE_THRESHOLD.RELAXED]: {
            labelKey: 'SILENCE_THRESHOLD_RELAXED_LABEL',
            ruleLabelKey: 'SILENCE_THRESHOLD_RELAXED_RULE_LABEL',
            helperKey: 'SILENCE_THRESHOLD_RELAXED_HELPER',
            platformsKey: 'SILENCE_THRESHOLD_RELAXED_PLATFORMS',
            seconds: 3
        }
    };
    
    // Determine initial value from searchParams
    const getInitialSliderValue = () => {
        const sec = searchParams?.maxSilenceInMilliseconds ? searchParams.maxSilenceInMilliseconds / 1000 : 1;
        if (sec <= 0) return SILENCE_THRESHOLD.FAST;
        if (sec <= 1) return SILENCE_THRESHOLD.SMOOTH;
        return SILENCE_THRESHOLD.RELAXED;
    };

    const [sliderValue, setSliderValue] = useState(getInitialSliderValue());
    const [isApplying, setIsApplying] = useState(false);

    // Update local state when search params change
    useEffect(() => {
        setSliderValue(getInitialSliderValue());
    }, [searchParams]);

    const handleSilenceThresholdChange = (value) => {
        setSliderValue(value);
    };

    const handleSilenceThresholdChangeComplete = async (value) => {
        const config = THRESHOLD_CONFIG[value];
        setSliderValue(value);
        setIsApplying(true);
        try {
            await searchWidgetModel.applySearchResultsForSilencesToTrim(
                config.seconds * 1000, // Convert to milliseconds
                true, // forceReset
                false, // keepCurrentIndexInFocus
                false  // useCachedSearchResults
            );
            // Notify parent of parameter change
            if (onSearchParamsChange) {
                onSearchParamsChange({
                    maxSilenceInMilliseconds: config.seconds * 1000
                });
            }
        } catch (error) {
            console.error('Error applying silence search:', error);
        } finally {
            setIsApplying(false);
        }
    };

    const tooltipFormatter = (value) => {
        const config = THRESHOLD_CONFIG[value];
        return (
            <div>
                 <div className="font-bold">{window.getI18n(ti18n, config.ruleLabelKey)}</div>
                 <div className="text-gray-400 mt-1 text-sm">{window.getI18n(ti18n, config.helperKey)} For: {window.getI18n(ti18n, config.platformsKey)}</div>
            </div>
        );
    };

    return (
        <div className="flex flex-col px-2 ">
            <div className="flex flex-col">
                <TrebbleSlider
                    min={0}
                    max={2}
                    step={1}
                    marks={{
                        [SILENCE_THRESHOLD.FAST]: <span style={{ whiteSpace: 'nowrap' }}>{window.getI18n(ti18n, THRESHOLD_CONFIG[SILENCE_THRESHOLD.FAST].labelKey)}</span>,
                        [SILENCE_THRESHOLD.SMOOTH]: <span style={{ whiteSpace: 'nowrap' }}>{window.getI18n(ti18n, THRESHOLD_CONFIG[SILENCE_THRESHOLD.SMOOTH].labelKey)}</span>,
                        [SILENCE_THRESHOLD.RELAXED]: <span style={{ whiteSpace: 'nowrap' }}>{window.getI18n(ti18n, THRESHOLD_CONFIG[SILENCE_THRESHOLD.RELAXED].labelKey)}</span>
                    }}
                    value={sliderValue}
                    onChange={handleSilenceThresholdChange}
                    onChangeComplete={handleSilenceThresholdChangeComplete}
                    disabled={isApplying}
                    useEditorTheme={true}
                    style={{ marginTop: '8px' }}
                    tooltip={{
                        formatter: tooltipFormatter,
                        placement: 'top',
                        autoAdjustOverflow: true
                    }}
                />
            </div>
        </div>
    );
};

EditorSearchParamsForSilenceSearch.propTypes = {
    searchParams: PropTypes.object,
    onSearchParamsChange: PropTypes.func,
    searchWidgetModel: PropTypes.object
};

export default EditorSearchParamsForSilenceSearch; 